<div class="price-container" [ngClass]="{ 'smaller-decimal' : smallerDecimal }">
  <span class="price-currency" [ngClass]="secondarySize">{{ price.currency }}</span>
  <span class="price-amount" [ngClass]="secondarySize">
    <h1 class="price-dollar" [ngClass]="primarySize">{{ price.amount | number: '1.' + format | slice: 0 : precision === 0 ? undefined : -3 }}</h1>
    <span *ngIf="precision !== 0" class="price-decimal" [ngClass]="decimalSize">{{ price.amount | number: '1.' + format | slice: -3 }}</span>
  </span>
  <span *ngIf="price.frequency" class="price-frequency" [ngClass]="secondarySize">/{{ price.frequency }}</span>
</div>
